import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, url, image }) {
  const siteName = 'Incomed';
  const defaultDescription = 'Incomed - Partner i sigurt në shëndetin tuaj. Shpërndarës i autorizuar i produkteve farmaceutike dhe medicinale në Shqipëri.';
  const defaultImage = 'https://incomed.al/favicon.png';
  const baseUrl = 'https://incomed.al';

  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Zgjedhje e Besueshme në Distribucion Farmaceutik`;
  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;
  const metaUrl = url ? `${baseUrl}${url}` : baseUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={metaUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:image" content={metaImage} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
}